var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { BaseNumberIdDataDto } from '../../../classes/common';
import { UserWithoutRelationsDto } from '../../../classes/user';
export class ManagerApprovalDto extends BaseNumberIdDataDto {
    constructor(initializer) {
        super(initializer);
        this.requestKey = initializer.requestKey;
        this.type = initializer.type;
        this.reservationId = initializer.reservationId;
        this.customerName = initializer.customerName;
        this.approvedAt = initializer.approvedAt;
        this.expiredAt = initializer.expiredAt;
        this.requestUser = initializer.requestUser;
    }
}
__decorate([
    Type(() => Date),
    __metadata("design:type", Object)
], ManagerApprovalDto.prototype, "approvedAt", void 0);
__decorate([
    Type(() => Date),
    __metadata("design:type", Date)
], ManagerApprovalDto.prototype, "expiredAt", void 0);
__decorate([
    Type(() => UserWithoutRelationsDto),
    __metadata("design:type", UserWithoutRelationsDto)
], ManagerApprovalDto.prototype, "requestUser", void 0);
